import { apiSlice } from '../app/api/apiSlice';

export const autoBuyApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get all rules for a specific swarm
    getSwarmRules: builder.query({
      query: ({swarmId, isDeleted}) => `/AutoBuy/rules/swarm/${swarmId}?isDeleted=${isDeleted}`,
      providesTags: (result, error, { swarmId }) => [
        { type: 'AutoBuyRules', id: `swarm-${swarmId}` },
      ],
      keepUnusedDataFor: 0,
    }),
    // Create or update rules for a specific swarm
    saveSwarmRules: builder.mutation({
      query: ({ swarmId, rules }) => ({
        url: `/AutoBuy/rules/swarm/${swarmId}`,
        method: 'POST',
        body: { rules }
      }),
      invalidatesTags: (result, error, { swarmId }) => [
        { type: 'AutoBuyRules', id: `swarm-${swarmId}` }
      ]
    }),
    // Get active rules for a specific swarm with counter information
    getActiveSwarmRules: builder.query({
      query: (swarmId) => `/AutoBuy/rules/swarm/active/${swarmId}`,
      providesTags: (result, error, swarmId) => [
        { type: 'AutoBuyRules', id: `swarm-${swarmId}` },
      ],
      keepUnusedDataFor: 0,
    }),
  }),
})

export const {
  useGetSwarmRulesQuery,
  useSaveSwarmRulesMutation,
  useGetActiveSwarmRulesQuery,
} = autoBuyApi;
